// extracted by mini-css-extract-plugin
module.exports = {"wrap_checkbox":"styles_wrap_checkbox__7MLuz","check_mark":"styles_check_mark__3ErMJ"};